import _extends from "@babel/runtime/helpers/esm/extends";
import { createNamespace } from '../utils';
import DatetimePicker from '../datetime-picker';
import Field from '../field';
import Popup from '../popup';
import dayjs from 'dayjs';

var _createNamespace = createNamespace('date-picker-field'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: _extends({}, DatetimePicker.props, Field.props, {
    value: {
      type: [String, Number, Date],
      default: null
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    formatValue: {
      type: String,
      default: 'YYYY-MM-DD'
    }
  }),
  data: function data() {
    return {
      currentDate: null,
      showPicker: false
    };
  },
  computed: {
    showValue: function showValue() {
      if (this.currentDate) {
        if (this.type === 'time') {
          return this.value;
        }

        return dayjs(this.currentDate).format(this.format);
      }

      return this.currentDate;
    }
  },
  watch: {
    value: function value(val) {
      this.currentDate = this.type === 'time' ? this.value : new Date(val);
    }
  },
  methods: {
    handleCancel: function handleCancel() {
      this.showPicker = false;
    },
    handleConfirm: function handleConfirm(val) {
      if (this.formatValue === 'timestamp' && this.type !== 'time') {
        val = new Date(val).getTime();
      }

      this.$emit('input', val);
      this.showPicker = false;
    },
    handleFocus: function handleFocus() {
      this.showPicker = true;
    },
    handlePopupInput: function handlePopupInput(val) {
      this.showPicker = val;
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      "class": bem()
    }, [h(Field, {
      "props": _extends({}, _extends({}, this.$props, {
        value: this.showValue,
        readonly: true
      })),
      "on": _extends({}, this.$listeners, {
        "focus": this.handleFocus
      }),
      "attrs": {
        "placeholder": "请选择时间"
      }
    }), h(Popup, {
      "attrs": {
        "value": this.showPicker,
        "position": "bottom",
        "show-toolbar": true
      },
      "on": {
        "input": this.handlePopupInput
      }
    }, [h(DatetimePicker, {
      "attrs": {
        "value": this.currentDate,
        "type": this.type,
        "minDate": this.minDate,
        "maxDate": this.maxDate,
        "filter": this.filter,
        "formatValue": this.formatValue,
        "format": this.format
      },
      "on": {
        "cancel": this.handleCancel,
        "confirm": this.handleConfirm
      }
    })])]);
  }
});